import React, { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { Row, Col } from 'reactstrap';
import { TypedMemo } from '../common/types';
import { SMLContainer } from '../smartLinks/smlContainer/SMLContainer';
import { SMLRouteNames, SMLRoutes } from '../../routing/sml/SMLRoutes';
import { useSMLRouter } from '../../routing/sml/hooks';
import { SMLDatePicker } from './components/SMLDatePicker/SMLDatePicker';
import { ArtistSearchField, MeiliArtistData } from './components/SearchField';
import { TopGainingArtistsCard } from './components/TopGainingArtistsCard/TopGainingArtistsCard';
import { TopOverallArtistCard } from './components/TopOverallArtistCard/TopOverallArtistCard';
import { ChartsPageHead } from './charts/ChartsPageHead';
import { PageTabsInBody } from './components/SMLPageHead/PageTabsInBody';
import { ChartsTabRow } from './charts/ChartsTabRow';

const SMLArtistsHomeComponent: React.FC = () => {
  const intl = useIntl();
  const router = useSMLRouter();

  // Handle artist selection from search - navigate to artist details
  const handleArtistSelected = useCallback(
    (artist: MeiliArtistData) => {
      router.push(SMLRoutes.artistDetails, { artistId: artist.id });
    },
    [router]
  );

  return (
    <SMLContainer
      header={
        <ChartsPageHead tab={SMLRouteNames.artists}>
          <SMLDatePicker />
        </ChartsPageHead>
      }
    >
      <PageTabsInBody>
        <ChartsTabRow screen={SMLRouteNames.artists} />
      </PageTabsInBody>
      <Row className="mb-4">
        <Col xs={12} md={6} lg={5}>
          <ArtistSearchField
            placeholder={intl.formatMessage({
              id: 'app.search.artists.placeholder',
              defaultMessage: 'Search for artists...',
            })}
            onArtistSelected={handleArtistSelected}
          />
        </Col>
      </Row>

      <Row>
        <Col xs={12} xl={6} className="pb-4">
          <TopGainingArtistsCard />
        </Col>
        <Col xs={12} xl={6} className="pb-4">
          <TopOverallArtistCard />
        </Col>
      </Row>
    </SMLContainer>
  );
};

export const SMLArtistsHome = TypedMemo(SMLArtistsHomeComponent);
